<template>
    <el-upload
    ref="uploadRef"
      class="image-uploader"
      :http-request="customUpload"
      :before-upload="beforeImageUpload"
      :show-file-list="false"
      accept="image/jpeg,image/png,image/gif"
    >
      <slot></slot>

    </el-upload>
  </template>
  
  <script setup lang="ts">
  import { ref } from 'vue'
  import { uploadImage, beforeImageUpload } from '@/api/uploadImage'
  import { ElMessage } from 'element-plus'
  
  const props = defineProps<{
    onSuccess?: (url: string) => void
  }>()
  const uploadRef = ref()
// 添加清除方法
const clearFiles = () => {
  if (uploadRef.value) {
    uploadRef.value.clearFiles()
    // 触发成功回调，传入空值
    props.onSuccess?.('')
  }
}

// 暴露方法给父组件
defineExpose({
  clearFiles
})

  const customUpload = async (options: any) => {
    try {
      const imageUrl = await uploadImage(options.file)
      console.log('上传的图片地址UploadComponent:', imageUrl)
      if (imageUrl) {
        props.onSuccess?.(imageUrl)
      }
    } catch (error) {
      console.error('上传失败:', error)
      ElMessage.error('上传失败，请重试')
    }
  }
  </script>